import { selectIsLoading, selectIsLoggedIn } from 'containers/Login/loginSlice'
import { fetchLocations } from 'containers/Maps/Result/locationSlice'
import { useReduxDispatch, useReduxSelector } from 'store'
import Dashboard from 'containers/Dashboard'
import Loading from 'components/Loading'
import Home from 'containers/Home'
import { useEffect } from 'react'

const type = process.env.REACT_APP_TYPE
const StartPage: React.FC = () => {
  const isLoggedIn = useReduxSelector(selectIsLoggedIn)
  const isLoading = useReduxSelector(selectIsLoading)

  const dispatch = useReduxDispatch()
  useEffect(() => {
    if (type !== 'mm' && type !== 'box') {
      dispatch(fetchLocations({}))
    }
  }, [dispatch])

  return (
    isLoggedIn
      ? <Dashboard />
      : isLoading
        ? <Loading middleOfPage />
        : <Home />
  )
}

export default StartPage